module.exports = __webpack_public_path__ + "img/webp_1.610f8432.gif";